import { pageable } from 'apis/core/commonSchema';
import { listingSearchParam } from 'apis/handler/listing/listingSchema';
import type { mainListingInfo } from 'apis/handler/listing/listingSchema';
import { apiClient } from 'shared/api';

import type { ListingResponse, MapPointsParam, MapPointsResponse, MapPreviewResponse } from '../model/dto';

export const getListing = async (
  searchParam: listingSearchParam,
  pageableParam: pageable,
): Promise<ListingResponse> => {
  const { agentCommentTypes, ...restSearchParam } = searchParam;

  const commentQuery = agentCommentTypes?.map((c) => `agentCommentTypes=${c}`).join('&');

  const endpoint = commentQuery ? `/listing?${commentQuery}` : '/listing';

  const { data } = await apiClient.get(endpoint, {
    ...restSearchParam,
    ...pageableParam,
  });

  return data.result;
};

export const getMapPoints = async (params: MapPointsParam): Promise<MapPointsResponse> => {
  const { agentCommentTypes, ...restParams } = params;

  const commentQuery = agentCommentTypes?.map((c) => `agentCommentTypes=${c}`).join('&');

  const endpoint = commentQuery ? `/listing/map-points?${commentQuery}` : '/listing/map-points';

  const { data } = await apiClient.get(endpoint, restParams as Record<string, string | number | boolean | undefined>);

  return data.result;
};

export const getListingMapPreview = async (id: number): Promise<MapPreviewResponse> => {
  const { data } = await apiClient.get(`/listing/${id}/map-preview`);

  return data.result;
};

export const getSimilarListings = async (id: string): Promise<mainListingInfo[]> => {
  const { data } = await apiClient.get(`/listing/${id}/similar`);

  return data.result;
};
